import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import config from '@/config';
const { API_URL } = config;

export const fetchCatalogs = createAsyncThunk('catalogs/fetch', async (paginationParams) => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/catalogs?${new URLSearchParams(paginationParams).toString()}`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const data = await response.json();
  return data;
});

export const fetchAllCatalogs = createAsyncThunk('catalogs/fetchAll', async () => {
  const token = localStorage.getItem('authToken');
  const response = await fetch(`${API_URL}/catalogs?all=true`, {
    headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` },
  });
  const data = await response.json();
  return data;
});

const catalogsSlice = createSlice({
  name: 'catalogs',
  initialState: {
    items: [],
    counts: 0,
    status: 'idle',
    error: null,
    allCatalogs: [],
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCatalogs.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchCatalogs.fulfilled, (state, action) => {
        if (action.payload.code === 200) {
          state.status = 'succeeded';
          state.items = action.payload?.data?.items ?? [];
          state.counts = action.payload?.data?.counts ?? 0;
          state.error = null;
        } else {
          state.status = 'failed';
          state.error = action.payload.message;
        }
      })
      .addCase(fetchCatalogs.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      })
      .addCase(fetchAllCatalogs.fulfilled, (state, action) => {
        if (action.payload.code === 200) {
          const data = action.payload?.data?.items ?? [];
          const groupedByType = {};

          data.forEach((item) => {
            if (!groupedByType[item.type]) {
              groupedByType[item.type] = [];
            }
            const customItem = { ...item, name: item.fields.name };
            groupedByType[item.type].push(customItem);
          });
          state.allCatalogs = groupedByType;
        } else {
          state.allCatalogs = [];
          console.log('Помилка завантаження всих каталогів.', action.payload.message);
        }
      });
  },
});

export default catalogsSlice.reducer;
